var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCube20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.3346V6.66425C17.4997 6.44593 17.4423 6.23148 17.3334 6.04226C17.2245 5.85304 17.0679 5.69564 16.8793 5.58573L10.9418 2.13026C10.6557 1.96372 10.3306 1.87598 9.99961 1.87598C9.66859 1.87598 9.34349 1.96372 9.05742 2.13026L3.1207 5.58573C2.93207 5.69564 2.77551 5.85304 2.66661 6.04226C2.55771 6.23148 2.50027 6.44593 2.5 6.66425V13.3346C2.50013 13.553 2.55751 13.7676 2.66641 13.957C2.77532 14.1464 2.93195 14.3039 3.1207 14.4139L9.0582 17.8693C9.34435 18.0356 9.66942 18.1232 10.0004 18.1232C10.3314 18.1232 10.6564 18.0356 10.9426 17.8693L16.8801 14.4139C17.0687 14.3038 17.2252 14.1462 17.3339 13.9569C17.4427 13.7675 17.4999 13.5529 17.5 13.3346Z",
    stroke: "#6B798F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 6.01562L10 10.3125L17.3047 6.01562M10 18.125V10.3125",
    stroke: "#6B798F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube20);
export default __webpack_public_path__ + "static/media/cube_20.1198b5634af177b30fc2e9c7f57a53f5.svg";
export { ForwardRef as ReactComponent };